<template>
  <div class="knowledge-info-content">
    <div class="knowledge-info">
      <div class="name">
        <div>{{ $t("page_ops_customer_basic_info") }}</div>
      </div>
      <a-row class="knowledge-info-detail">
        <a-col class="knowledge-info-detail-col" :span="24">
          <div class="knowledge-info-detail-col-name">{{ $t("page_alarm_alarmcode") }}：</div>
          <div>
            {{ detail.issueCode }}
          </div>
        </a-col>
        <a-col class="knowledge-info-detail-col" :span="24">
          <div class="knowledge-info-detail-col-name">{{ $t("page_ops_knowledge_equipment_model") }}：</div>
          <div>{{ detail.deviceTypeName }}</div>
        </a-col>
        <a-col class="knowledge-info-detail-col" :span="24">
          <div class="knowledge-info-detail-col-name">{{ $t("page_ops_knowledge_alarm_message") }}：</div>
          <div class="knowledge-info-detail-col-value">{{ detail.issueDesc }}</div>
        </a-col>
      </a-row>
    </div>
    <div class="knowledge-info">
      <div class="name">
        <div>{{ $t("page_ops_knowledge_alarm_details") }}</div>
      </div>
      <a-row class="knowledge-info-detail">
        <a-col class="knowledge-info-detail-col" :span="24">
          <div class="knowledge-info-detail-col-name">{{ $t("page_ops_knowledge_equipment_type") }}：</div>
          <div>{{ detail.issueType }}</div>
        </a-col>
        <a-col class="knowledge-info-detail-col" :span="24">
          <div class="knowledge-info-detail-col-name">{{ $t("page_ops_knowledge_severity_level") }}：</div>
          <div>
            <a-tag color="orange">
              {{ detail.issueLevel }}
            </a-tag>
          </div>
        </a-col>
        <a-col class="knowledge-info-detail-col" :span="24">
          <div class="knowledge-info-detail-col-name">{{ $t("page_ops_knowledge_alarm_source") }}：</div>
          <div class="knowledge-info-detail-col-value">{{ detail.issueSource  }}</div>
        </a-col>
        <a-col class="knowledge-info-detail-col" :span="24">
          <div class="knowledge-info-detail-col-name">{{ $t("page_ops_knowledge_alarm_reason") }}：</div>
          <div class="knowledge-info-detail-col-value">{{ detail.causedBy }}</div>
        </a-col>
      </a-row>
    </div>
    <div class="knowledge-info">
      <div class="name">
        <div>{{ $t("page_ops_knowledge_treatment_measures") }}</div>
      </div>
      <a-row class="knowledge-info-detail">
        <a-col class="knowledge-info-detail-col" :span="24">
          <div class="knowledge-info-detail-col-name">{{ $t("page_ops_knowledge_treatment_measures") }}：</div>
          <div v-html="detail.solution"></div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { KnowledgeLibraryServiceProxy } from '@/service-proxies/app-v2/knowledge-library.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const klsp = new KnowledgeLibraryServiceProxy()
const dbsp = new DictServiceProxy()
export default {
  name: 'KnowledgeDetail',
  components: {},
  props: {
    knowledge: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { 
      detail: {},
      issueTypeMap: new Map()
    }
  },
  async created() {
    let res = await dbsp.dictionary("issue-type")
    res.data.forEach(x=>this.issueTypeMap.set(x.dictKey,x.dictValue))
  },
  watch: {
    knowledge(val) {
      if (!(val && val.deviceTypeId)) {
        this.detail = {}
        return
      }
      this.getDetail()
    },
    deep: true,
    immediate: true
  },
  methods: {
    getDetail() {
      klsp
        .getKnowledgeLibraryDetail(this.knowledge.deviceTypeId, '', this.knowledge.issueCode)
        .then((res) => {
          this.detail = res
          this.detail.issueType = this.issueTypeMap.get(res.issueType)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.knowledge-info-detail-col-name{
  min-width: 75px;
}
.knowledge-info-detail-col-value{
  word-break: break-word;
}
.knowledge-info-content {
  padding: 8px 0;
  height: 100%;
  overflow: auto;
  .knowledge-info {
    padding: 4px 8px;
    .name {
      color: #5395ca;
      font-size: 15px;
      font-weight: bold;
      line-height: 18px;
      border-left: 3px solid #5395ca;
      padding-left: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .knowledge-info-detail {
      padding: 9px 0;
      &-col {
        padding: 9px 14px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        &-name {
          width: 75px;
          text-align: right;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
